import MetaTags from "react-meta-tags";
import React, { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import { withRouter, Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import logo from "../../assets/images/logo.png";
import { IResetUserPassword } from "src/models/Maintenance/User.models";
import { UserAPIService } from "src/api/Maintenance/API_UserService";
import { History } from "history";
import loginBG from "../../assets/images/login-bg.png";
import { VERSION } from "src/constants/version";

interface ForgetPasswordProps {
  history: History;
}

const ForgetPasswordPageNew = ({ history }: ForgetPasswordProps) => {
  let formRef: any = null;
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    return () => {
      setLoading(null as any);
    };
  }, []);

  const handleValidSubmit = async (event: any, values: IResetUserPassword) => {
    setLoading(true);
    try {
      const response = await UserAPIService.resetPassword(values);
      if (response?.success) {
        formRef?.reset();
        history.push("/login");
      }
    } catch (ex) {
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <React.Fragment>
      <MetaTags>
        <title>DualCloud ERP | Reinicio de Contraseña</title>
      </MetaTags>
      <div className="app app-without-header">
        <div className="p-0">
          <div className="login login-v1">
            <div className="login-container" style={{ flex: 2, alignItems: 'center', justifyContent: 'center'  }}>

              <div className="login-header" style={{paddingBottom: "0 !important"}}>
                <div className="brand">
                  <img src={logo} alt="logo" width="200" />
                  <h4 className="mt-3">¿Has olvidado tu contraseña?</h4>
                </div>
              </div>
              <div className="jp">
                <p>Enviaremos una contraseña temporal a tu correo electrónico para que puedas ingresar nuevamente.</p>
              </div>

              <div className="login-body">
                <div className="login-content fs-13px">
                    <div className="auth-content my-auto">
                      <AvForm
                        ref={(ref: any) => {
                          if (formRef == null || formRef == undefined) {
                            formRef = ref;
                          }
                          return ref;
                        }}
                        className="custom-form pt-2"
                        onValidSubmit={(e: any, v: any) =>
                          handleValidSubmit(e, v)
                        }
                      >
                        <div className="mb-3">
                          <AvField
                            name="email"
                            label="Correo electrónico"
                            className="form-control"
                            placeholder="Ingresa tu correo electrónico"
                            type="email"
                            errorMessage="Correo electrónico es inválido"
                            validate={{
                              email: true,
                              required: {
                                value: true,
                                errorMessage: "Este campo es requerido",
                              },
                            }}
                          />
                        </div>
                        <div className="mb-3 mt-5">
                          <button
                            disabled={loading}
                            className="btn btn-primary w-100 waves-effect waves-light"
                            type="submit"
                          >
                            {loading ? (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                            ) : null}
                            {!loading ? "Reiniciar contraseña" : ""}
                          </button>
                        </div>
                      </AvForm>

                      <div className="mt-5 text-center">
                        <p className="mb-0">
                          <i style={{color:"#2196F3"}} className="fa-solid fa-chevron-left d-none d-xl-inline-block" />
                          <Link
                            to="/login"
                            className="text-primary fw-semibold"
                            style={{textDecoration:"none"}}
                          >
                            {"  "}
                            <span style={{textDecoration:"none", fontWeight: 600}}>Regresa a Iniciar sesión{" "}</span>
                          </Link>{" "}
                        </p>
                      </div>
                    </div>
                    <div className="mt-4 mt-md-5 text-center">
                      <p className="mb-0">
                        © {new Date().getFullYear()} DualTech - v. {VERSION}
                      </p>
                    </div>
                </div>
              </div>
            </div>
            <div className="p-0" style={{flex: 2, display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
              <img src={loginBG} alt="LogoImage" style={{
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                maxWidth: '1000px',
                minWidth: '700px',
                width: "100%", /* 100% del ancho del contenedor */
                height: "100%",
                minHeight: '100vh',
                maxHeight: '100vh',
                objectFit: "cover",
                marginLeft: 'auto'
              }}/>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ForgetPasswordPageNew);
